// actions/connect/feedback.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectFeedbackHasErrored(bool) {
  return {
    type: 'CONNECT_FEEDBACK_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectFeedbackIsLoading(bool) {
  return {
    type: 'CONNECT_FEEDBACK_IS_LOADING',
    isLoading: bool
  };
}

export function connectFeedbackFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_FEEDBACK_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectFeedbackFetchData(host, msg) {
  return (dispatch) => {
    dispatch(connectFeedbackIsLoading(true));
    dispatch(connectFeedbackHasErrored(false));
    fetch(host + 'connect/feedback', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectFeedbackFetchDataSuccess(result));
            dispatch(connectFeedbackHasErrored(false));
            dispatch(connectFeedbackIsLoading(false));
            PubSub.publish('feedback.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectFeedbackHasErrored(true));
            dispatch(connectFeedbackIsLoading(false));
            PubSub.publish('feedback.response.error');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectFeedbackHasErrored(true));
      dispatch(connectFeedbackIsLoading(false));
      PubSub.publish('feedback.response.error');
    });
  };
}